import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import { FormButtons, renderers, Slider } from '../../components'
import Moment from 'react-moment'
import * as rest from '../../services'
import { change, Field, reduxForm } from 'redux-form'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'

const FORM_NAME = 'orderLine-form'
let OrderLineForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  dispatch,
  ticket,
}) => {
  const [availableInventoryItems, setAvailableInventoryItems] = useState([])

  const onSelectionChanged = (item) => {
    dispatch(change(FORM_NAME, 'inventory_item', item.url))
  }

  const onFilter = (payload) => {
    rest.TicketService.call_url_action(
      `${ticket.url}get_applicable_repair_spares/`,
      'GET',
      payload
    )
      .then((response) => {
        setAvailableInventoryItems(response)
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
    <form onSubmit={handleSubmit}>
      <components.SelectableTable
        myChangeHandler={true}
        onFilter={onFilter}
        columns={[
          {
            dataField: 'serial_number',
            text: 'Serial number',
          },
          {
            dataField: 'part_number',
            text: 'Part Number',
          },
          {
            dataField: 'created_by',
            text: 'Created By',
          },
        ]}
        items={availableInventoryItems}
        OnSelectionChanged={onSelectionChanged}
      />
      <Field
        name="inventory_item"
        label="inventory_item"
        // validate={[validations.required]}
        component={renderers.renderHiddenField}
        type="text"
      />
      <ReactBootstrap.Row className="pl-3 pr-3">
        <ReactBootstrap.Col>
          <Field
            name="component_issue"
            label="Component Issue"
            component={renderers.renderSelectField}
            as="select"
          >
            {ticket.device?.component_issues?.map((comptia) => {
              return (
                <option key={comptia.url} value={comptia.url}>
                  {comptia.component_description} - {comptia.issue_description}
                </option>
              )
            })}
          </Field>

          <Field
            name="kbb_serial_number"
            label="KBB Serial Number"
            // validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />

          <Field
            name="amount"
            label="Amount"
            // validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
          <Field
            component={renderers.renderSelectField}
            as="select"
            // validate={[validations.required]}
            name="coverage_option"
            label="Coverage Option"
          >
            {[
              'BATTERY',
              'DISPLAY',
              'VMI_YELLOW',
              'APPLECARE_PLUS',
              'VMI_RED',
              'VMI_GREEN',
              'THEFTLOSS',
            ].map((state) => {
              return (
                <option key={state} value={state}>
                  {state}
                </option>
              )
            })}
          </Field>
          <Field
            component={renderers.renderSelectField}
            as="select"
            // validate={[validations.required]}
            name="pricing_option"
            label="Pricing Option"
          >
            {[
                {lable:'DSPLY',value:'DSPLY'},
                {lable:'BAT',value:'BAT'},
                 {lable:'Part Required for Repair',value:'NOCHG'},
               ].map((state) => {
              return (
                <option key={state.lable} value={state.value}>
                  {state.lable}
                </option>
              )
            })}
          </Field>
          <div>
            <label htmlFor="from_consigned_stock">
              Is From Consigned Stock?
            </label>

            <Field
              name={`from_consigned_stock`}
              id={`from_consigned_stock`}
              component="input"
              type="checkbox"
            />
          </div>
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>

      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
OrderLineForm = reduxForm({
  form: FORM_NAME,
})(OrderLineForm)

export const OrderLineDelete = ({ orderLine, onDelete }) => {
  const dispatch = useDispatch()
  let OnDeleteConfirm = function () {
    new rest.OrderLineService(orderLine.url)
      .makeDeleteRequest()
      .then((response) => {
        onDelete(response)
        dispatch(showSuccessToast('Success', 'Order Line Deleted successfully'))
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={OnDeleteConfirm}
        body="Are you sure you want to delete this Orderline?"
        confirmText="Confirm delete Orderline"
        confirmBSStyle="danger"
        title="Confirm delete Orderline"
      >
        <ReactBootstrap.Button
          disabled={orderLine.is_deleted}
          variant="danger"
          eventKey="1"
        >
          {components.ICONS.DELETE} Delete
        </ReactBootstrap.Button>
      </components.Confirm>
    </>
  )
}

const OrderLine = ({ticket, orderLine, onTicketUpdate }) => {
  const {
    created_at,
    inventory_item_serial_number,
    kbb_serial_number,
    amount,
    inventory_item_description,
    inventory_item_part_number,
  } = orderLine

    const onUpdate=(ol)=>{

   const order_lines = ticket.order_lines.map((l) => {
           return l.url === ol.url ? ol : l
       }
      )
   const t = {...ticket,order_lines:order_lines}
      onTicketUpdate(t)
  }
  return (
    <ReactBootstrap.Row>
      <ReactBootstrap.Col className={'p-0'} xs="6">
        <strong>KGB: {inventory_item_serial_number || 'N/A'}-</strong>

        <sub>
          <Moment fromNow>{created_at}</Moment>
        </sub>
        <p style={{ wordWrap: 'break-word' }} className="text-justify">
          <strong>KBB:</strong> {kbb_serial_number || 'N/A'}
          <br />
          <strong>Description :</strong>
          {inventory_item_description || 'N/A'}
          <br />
          <strong>Part Number :</strong> {inventory_item_part_number || 'N/A'}
          <br />
          <strong>Amount : </strong>
          {amount || 'N/A'}
        </p>
      </ReactBootstrap.Col>
      <ReactBootstrap.Col className="p-0 text-end" xs="6">
        <OrderLineDelete orderLine={orderLine} onDelete={onUpdate} />
      </ReactBootstrap.Col>
    </ReactBootstrap.Row>
  )
}

export const TicketOrderLines = ({ ticket, onTicketUpdate }) => {
  const dispatch = useDispatch()
  const createOrderLine = (values) => {
    values.ticket = ticket.url
    new rest.OrderLineService()
      .makePostRequest(values)
      .then((response) => {
        const newOrderLines  = [response,...ticket.order_lines]
        onTicketUpdate({...ticket,order_lines:newOrderLines})
        dispatch(showSuccessToast('Success', 'Order Line created successfully'))
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }
  return (
    <ReactBootstrap.Card className="mt-5">
      <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs="6">Order Lines</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-end" xs="6">
            <Slider
              title={components.ICONS.PLUS}
              header={
                <>
                  <span className="mr-3">{components.ICONS.PLUS}</span>
                  <span>Add Order Lines</span>
                </>
              }
            >
              <OrderLineForm ticket={ticket} onSubmit={createOrderLine} />
            </Slider>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Title>
      <ReactBootstrap.Card.Body>
        {ticket?.order_lines?.length ? (
          <components.ItemList
            className="mt-5"
            itemRenderer={(index, key) => {
              return (
                <ReactBootstrap.Col key={ticket.order_lines[index].url}>
                  <OrderLine
                    ticket={ticket}
                    orderLine={ticket.order_lines[index]}
                    onTicketUpdate={onTicketUpdate}
                  />
                </ReactBootstrap.Col>
              )
            }}
            length={ticket.order_lines.length}
          />
        ) : (
          <ReactBootstrap.Alert variant={'info'}>
            No previous Order Lines found.
          </ReactBootstrap.Alert>
        )}
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
